import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmi00300-list-container q-mb-lg" }
const _hoisted_2 = { class: "row items-center" }
const _hoisted_3 = {
  class: "row q-gutter-lg items-center",
  style: {"width":"210px","margin-right":"20px"}
}
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "full-width row q-gutter-sm" }
const _hoisted_6 = { class: "q-pt-xs" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "row items-center" }
const _hoisted_9 = {
  class: "row q-gutter-lg items-center",
  style: {"width":"210px","margin-right":"20px"}
}
const _hoisted_10 = { class: "count" }
const _hoisted_11 = {
  class: "row justify-between items-center",
  style: {"width":"calc(100% - 206px)"}
}
const _hoisted_12 = { class: "row justify-end" }
const _hoisted_13 = { style: {"width":"140px"} }
const _hoisted_14 = { class: "freeword-search-area row items-center" }
const _hoisted_15 = { class: "col-5" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "full-width row q-gutter-sm" }
const _hoisted_18 = { class: "q-pt-xs" }
const _hoisted_19 = { class: "flex" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from 'axios';
import saveAs from 'file-saver';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import base64toBlob from '../../common/utils/fileUtils';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface MKaiinNotConfirmed {
  user_id: string;
  user_name_sei: string;
  user_name_mei: string;
  mail_address: string;
  work_school_name: string;
  create_timestamp: string;
}
// 会員情報(確認済)
interface MKaiinConfirmed {
  user_id: string;
  user_name_sei: string;
  user_name_mei: string;
  auth_level: string;
  mail_address: string;
  work_school_name: string;
  customer_cd: string;
  approval_stat: string;
  create_timestamp: string;
  update_timestamp: string;
}

// 会員情報(未確認)
const blank = '　';
// 未確認会員リスト
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'CMI00300',
  setup(__props) {

const router = useRouter();

// 会員情報(未確認)
const MKaiinNotConfirmedRows = ref([
  {
    user_id: '',
    create_timestamp: '',
    work_school_name: '',
    user_name_sei: '',
    user_name_mei: '',
    mail_address: '',
  },
]);
// 会員情報(確認済)
const MKaiinConfirmedRows = ref([
  {
    user_id: '',
    user_name_sei: '',
    user_name_mei: '',
    auth_level: '',
    mail_address: '',
    work_school_name: '',
    customer_cd: '',
    approval_stat: '',
    create_timestamp: '',
    update_timestamp: '',
  },
]);

// 会員情報(確認済承認済み)
const MKaiinConfirmedRowsApproval = ref([
  {
    user_id: '',
    user_name_sei: '',
    user_name_mei: '',
    auth_level: '',
    mail_address: '',
    work_school_name: '',
    customer_cd: '',
    approval_stat: '',
    create_timestamp: '',
    update_timestamp: '',
  },
]);

// user_name_seiとuser_name_meiの間に入れる空白
const NotConfirmedList: Array<any> = [
  {
    name: 'editDelete',
    field: (row: MKaiinNotConfirmed) => row.user_name_sei + blank + row.user_name_mei,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: (row: MKaiinNotConfirmed) =>
      row.create_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    sortable: true,
    style: 'width: 150px',
  },
  {
    name: 'work_school_name',
    label: '勤務先 / 学校名',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.work_school_name,
    sortable: true,
  },
  {
    name: 'user_name_sei + user_name_mei',
    label: '氏名',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.user_name_sei + blank + row.user_name_mei,
    sortable: true,
  },
  {
    name: 'mail_address',
    label: '会員ID（メールアドレス）',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.mail_address,
    sortable: true,
  },
];

// 確認済み会員リスト
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: MKaiinConfirmed) => row.user_name_sei + blank + row.user_name_mei,
  },
  {
    name: 'approval_stat',
    key: 'approval_stat',
    label: '承認状況',
    align: 'left',
    field: (row: MKaiinConfirmed) => (row.approval_stat === '0' ? '未承認' : '承認済み'),
    style: 'width: 100px',
    sortable: true,
  },
  {
    name: 'mail_address',
    label: '会員ID（メールアドレス）',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.mail_address,
    sortable: true,
  },
  {
    name: 'name',
    label: '氏名',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.user_name_sei + blank + row.user_name_mei,
    sortable: true,
  },
  {
    name: 'authrize',
    label: 'ユーザー権限',
    align: 'left',
    field: (row: MKaiinConfirmed) => (row.auth_level === 'MEMBER' ? '一般ユーザー' : '管理者'),
    sortable: true,
  },
  {
    name: 'customer_code',
    label: '得意先コード',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.customer_cd,
    sortable: true,
  },
  {
    name: 'business_school',
    label: '勤務先 / 学校名',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.work_school_name,
    sortable: true,
  },
  {
    name: 'regist_date',
    label: '登録日時',
    align: 'left',
    field: (row: MKaiinConfirmed) =>
      row.create_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    style: 'width: 150px',
    sortable: true,
  },
  {
    name: 'updated_date',
    label: '更新日時',
    align: 'left',
    field: (row: MKaiinConfirmed) =>
      row.update_timestamp === null
        ? ''
        : row.update_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    style: 'width: 150px',
    sortable: true,
  },
];
// 入力値
const inputData = reactive({
  searchWord: '',
  userIdInfo: '',
  excelFlag: true,
});
// 会員削除確認ダイアログフラグ
const deleteNotConfirmedFlag = ref(false);
// 会員削除確認ダイアログフラグ
const deleteConfirmedFlag = ref(false);
// 会員削除ダイアログフラグ
const deleteConpFlag = ref(false);
// Excelダイアログフラグ
const excelFlag = ref(false);
// Excelダウンロード完了ダイアログフラグ
const excelConpFlag = ref(false);
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

/**
 * 会員一覧取得処理
 */
const getMembersInfo = async () => {
  // Loading Start
  Loading.show();
  axios
    .post('/cmi003001/members')
    .then((res) => {
      const { common, mkaiinNotConfirmed, mkaiinConfirmed, mkaiinConfirmedApproved } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          MKaiinNotConfirmedRows.value = mkaiinNotConfirmed;
          MKaiinConfirmedRows.value = mkaiinConfirmed;
          MKaiinConfirmedRowsApproval.value = mkaiinConfirmedApproved;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * 会員検索処理
 */
const getSearchMemberInfo = async () => {
  // Loading Start
  Loading.show();
  // 検索データ作成
  const formData = new FormData();
  formData.append('searchWord', inputData.searchWord);
  axios
    .post('/cmi003001/members/search', formData)
    .then((res) => {
      const { common, mkaiinConfirmed, mkaiinConfirmedApproved } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          MKaiinConfirmedRows.value = mkaiinConfirmed;
          MKaiinConfirmedRowsApproval.value = mkaiinConfirmedApproved;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * 検索条件のリセット
 *
 */
const resetForm = async () => {
  inputData.searchWord = '';
  getMembersInfo();
};

/**
 * Excel出力処理
 */
const downloadExcel = async () => {
  // Loading Start
  Loading.show();
  // 検索データ作成
  const formData = new FormData();
  formData.append('searchWord', inputData.searchWord);
  if (inputData.excelFlag) {
    formData.append('selectFlag', '0');
  } else {
    formData.append('selectFlag', '1');
  }

  // Excel出力
  await axios
    .post('/cmi003001/members/excelOutput', formData)
    .then((res) => {
      const { common, body, file_name } = res.data;
      const blob = new Blob([
        base64toBlob(body, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
      ]);
      saveAs(blob, file_name);
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          excelConpFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 会員削除確認処理（未確認一覧）
 *
 */
const deleteNotConfirmed = async (userId: string) => {
  inputData.userIdInfo = userId;
  deleteNotConfirmedFlag.value = true;
};
/**
 * 会員削除確認処理（確認済み一覧）
 *
 */
const deleteConfirmed = async (userId: string) => {
  inputData.userIdInfo = userId;
  deleteConfirmedFlag.value = true;
};

/**
 * 会員削除処理
 *
 */
const deleteMember = async (userId: string) => {
  // Loading Start
  Loading.show();
  // データ作成
  const formData = new FormData();
  formData.append('user_id', userId);

  await axios
    .post('/cmi003001/member/delete', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          deleteNotConfirmedFlag.value = false;
          deleteConfirmedFlag.value = false;
          deleteConpFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
const panel = ref(true);

// 承認設定画面への遷移
const approvalSetting = (userId: string) => {
  router.push({ name: 'approvalSetting', params: { userId } });
};

// 初期表示
getMembersInfo();

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[13] || (_cache[13] = [
        _createTextVNode("会員一覧")
      ])),
      "button-area": _withCtx(() => [
        _createVNode(_component_q_btn, {
          color: "primary",
          icon: "mdi-plus",
          label: "新規管理者登録",
          to: { name: 'adminRegist', params: { login: '1' } }
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_list, {
        bordered: "",
        class: "rounded-borders unconfirmed-memberlist"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_expansion_item, {
            modelValue: panel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((panel).value = $event)),
            "expand-icon-toggle": "",
            "expand-separator": ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                        _createElementVNode("span", { class: "title" }, "未確認")
                      ], -1)),
                      _createElementVNode("label", _hoisted_4, _toDisplayString(MKaiinNotConfirmedRows.value.length), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_space)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(
              'chem-table-area btn-exist ' +
              (MKaiinNotConfirmedRows.value.length === 0 ? 'table-nodata' : '')
            )
              }, [
                _createVNode(_component_q_table, {
                  class: "my-sticky-header-column-member-table",
                  columns: NotConfirmedList,
                  rows: MKaiinNotConfirmedRows.value,
                  "row-key": "index",
                  flat: "",
                  dense: "",
                  separator: "cell",
                  "hide-no-data": hideNoDataFlg.value,
                  "no-data-label": "データがありません。",
                  "rows-per-page-options": [10, 20, 50, 0],
                  "rows-per-page-label": "件表示",
                  "rows-per-page": "20",
                  "pagination-label": 
                (firstRowIndex, endRowIndex, totalRowsNumber) => {
                  return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
                }
              
                }, {
                  "no-data": _withCtx(({ message }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_q_icon, {
                        size: "24px",
                        name: "mdi-alert-circle-outline"
                      }),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(message), 1)
                    ])
                  ]),
                  "header-cell-editDelete": _withCtx(() => [
                    _createVNode(_component_q_th, { class: "table-btn-area approvalbtn-exist" })
                  ]),
                  "body-cell-editDelete": _withCtx((cell) => [
                    (!hideNoDataFlg.value)
                      ? (_openBlock(), _createBlock(_component_q_td, {
                          key: 0,
                          class: "table-btn-area approvalbtn-exist"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_q_btn, {
                                color: "primary",
                                icon: "mdi-account-supervisor",
                                label: "承認設定",
                                style: {"width":"120px"},
                                onClick: _withModifiers(($event: any) => (approvalSetting(cell.row.user_id)), ["stop"])
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                label: "削除",
                                icon: "mdi-close",
                                class: "deletebtn",
                                color: "primary",
                                outline: "",
                                style: {"color":"var(--q-delete)"},
                                onClick: ($event: any) => (deleteNotConfirmed(cell.row.user_id))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  "body-cell": _withCtx((body) => [
                    (!hideNoDataFlg.value)
                      ? (_openBlock(), _createBlock(_component_q_td, {
                          key: 0,
                          props: body
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(body.value), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["rows", "hide-no-data", "pagination-label"])
              ], 2)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_list, { class: "rounded-borders confirmed-memberlist" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "q-mb-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "title" }, "確認済み")
                  ], -1)),
                  _createElementVNode("label", _hoisted_10, _toDisplayString(inputData.excelFlag
                  ? MKaiinConfirmedRows.value.length
                  : MKaiinConfirmedRowsApproval.value.length), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_q_toggle, {
                    modelValue: inputData.excelFlag,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputData.excelFlag) = $event)),
                    "hide-details": "",
                    label: `未承認表示`,
                    "true-val": true,
                    "false-val": false
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_q_btn, {
                        color: "primary",
                        class: _normalizeClass(
                      'export-btn excel-exportbtn ' +
                      ((inputData.excelFlag
                        ? MKaiinConfirmedRows.value.length
                        : MKaiinConfirmedRowsApproval.value.length) === 0
                        ? 'cmi00300-disabled-btn'
                        : '')
                    ),
                        outline: 
                      (inputData.excelFlag
                        ? MKaiinConfirmedRows.value.length
                        : MKaiinConfirmedRowsApproval.value.length) !== 0
                        ? true
                        : false
                    ,
                        icon: "mdi-download",
                        "no-caps": "",
                        disable: 
                      (inputData.excelFlag
                        ? MKaiinConfirmedRows.value.length
                        : MKaiinConfirmedRowsApproval.value.length) === 0
                    ,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (excelFlag.value = true))
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("Excel出力")
                        ])),
                        _: 1
                      }, 8, ["class", "outline", "disable"]),
                      (
                      inputData.excelFlag
                        ? MKaiinConfirmedRows.value.length === 0
                        : MKaiinConfirmedRowsApproval.value.length === 0
                    )
                        ? (_openBlock(), _createBlock(_component_q_tooltip, {
                            key: 0,
                            anchor: "top right",
                            offset: [-70, 8],
                            self: "bottom middle"
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createElementVNode("strong", null, "検索結果が存在しません。", -1)
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_form, {
            novalidate: "",
            onSubmit: getSearchMemberInfo
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_q_input, {
                    id: "searchWord",
                    ref: "searchWord",
                    modelValue: inputData.searchWord,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputData.searchWord) = $event)),
                    name: "searchWord",
                    outlined: "",
                    dense: "",
                    maxlength: "100",
                    style: {"background":"var(--q-white)"},
                    class: "q-mr-xs input-area",
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    class: "q-mr-xs",
                    icon: "mdi-magnify",
                    label: "検索",
                    type: "search"
                  }),
                  _createVNode(_component_q_btn, {
                    style: {"color":"var(--q-delete)"},
                    outline: "",
                    icon: "mdi-eraser",
                    label: "クリア",
                    onClick: resetForm
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass(
            'chem-table-area confirmed-table-area btn-exist ' +
            (inputData.excelFlag
              ? MKaiinConfirmedRows.value.length === 0
                ? 'table-nodata'
                : ''
              : MKaiinConfirmedRowsApproval.value.length === 0
              ? 'table-nodata'
              : '')
          )
          }, [
            _createVNode(_component_q_table, {
              class: "my-sticky-header-column-member-table justify-between",
              columns: columns,
              rows: inputData.excelFlag ? MKaiinConfirmedRows.value : MKaiinConfirmedRowsApproval.value,
              "row-key": "index",
              flat: "",
              dense: "",
              separator: "cell",
              "hide-no-data": hideNoDataFlg.value,
              "no-data-label": "データがありません。",
              "rows-per-page-options": [10, 20, 50, 0],
              "rows-per-page-label": "件表示",
              "rows-per-page": "20",
              "pagination-label": 
              (firstRowIndex, endRowIndex, totalRowsNumber) => {
                return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
              }
            
            }, {
              "no-data": _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_q_icon, {
                    size: "24px",
                    name: "mdi-alert-circle-outline"
                  }),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(message), 1)
                ])
              ]),
              "header-cell-editDelete": _withCtx(() => [
                _createVNode(_component_q_th, { class: "table-btn-area approvalbtn-exist" })
              ]),
              "body-cell-editDelete": _withCtx((body) => [
                (!hideNoDataFlg.value)
                  ? (_openBlock(), _createBlock(_component_q_td, {
                      key: 0,
                      class: "table-btn-area approvalbtn-exist"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_q_btn, {
                              icon: "mdi-account-supervisor",
                              color: "primary",
                              style: {"width":"120px"},
                              disabled: body.row.auth_level === 'ADMIN',
                              onClick: ($event: any) => (approvalSetting(body.row.user_id))
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" 承認設定 ")
                              ])),
                              _: 2
                            }, 1032, ["disabled", "onClick"]),
                            (body.row.auth_level === 'ADMIN')
                              ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                  key: 0,
                                  anchor: "top left",
                                  offset: [-70, 4],
                                  self: "bottom middle"
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createElementVNode("strong", null, "管理者アカウントの情報は変更できません。", -1)
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_q_btn, {
                              label: "削除",
                              icon: "mdi-close",
                              class: "deletebtn",
                              color: "primary",
                              outline: "",
                              style: {"color":"var(--q-delete)"},
                              onClick: ($event: any) => (deleteConfirmed(body.row.user_id))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              "body-cell": _withCtx((cell) => [
                (!hideNoDataFlg.value)
                  ? (_openBlock(), _createBlock(_component_q_td, {
                      key: 0,
                      props: cell
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cell.value), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["rows", "hide-no-data", "pagination-label"])
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(AlertDialog, {
        display: deleteNotConfirmedFlag.value,
        title: "削除確認",
        level: "information",
        text: ['会員登録せずに削除します。', 'よろしいですか？'],
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (deleteMember(inputData.userIdInfo))),
        onClose: _cache[6] || (_cache[6] = ($event: any) => (deleteNotConfirmedFlag.value = false))
      }, null, 8, ["display"]),
      _createVNode(AlertDialog, {
        display: deleteConfirmedFlag.value,
        title: "削除確認",
        level: "information",
        text: ['会員情報を削除します。', 'よろしいですか？'],
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (deleteMember(inputData.userIdInfo))),
        onClose: _cache[8] || (_cache[8] = ($event: any) => (deleteConfirmedFlag.value = false))
      }, null, 8, ["display"]),
      _createVNode(AlertDialog, {
        display: deleteConpFlag.value,
        level: "information",
        confirmation: "",
        title: "会員削除完了",
        text: ['会員情報を削除しました。'],
        onComplete: _cache[9] || (_cache[9] = ($event: any) => ((deleteConpFlag.value = false), getMembersInfo()))
      }, null, 8, ["display"]),
      _createVNode(AlertDialog, {
        display: excelFlag.value,
        title: "Excel出力確認",
        level: "information",
        text: ['会員情報のExcelファイルを出力します。', 'よろしいですか？'],
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => ((excelFlag.value = false), downloadExcel())),
        onClose: _cache[11] || (_cache[11] = ($event: any) => (excelFlag.value = false))
      }, null, 8, ["display"]),
      _createVNode(AlertDialog, {
        display: excelConpFlag.value,
        level: "information",
        confirmation: "",
        title: "Excel出力完了",
        text: ['会員情報のExcelファイルを出力しました。'],
        onComplete: _cache[12] || (_cache[12] = ($event: any) => (excelConpFlag.value = false))
      }, null, 8, ["display"])
    ])
  ]))
}
}

})